<template>
    <div class="main-wrap area">
        <div class="title">
            <div class="text">
                <span class="str">{{t('main')}}</span>
            </div>
            <div class="name cf">
                <div class="fl">
                    <span class="icon icon-point"></span>
                    <tv k="welcome"></tv>
                </div>
                <div class="fr">
                    <span>{{date}}</span>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="left">
                <div>
                    <div class="sub-title">{{date}}</div>
                </div>
                <div class="group1">
                    <div class="sub-title"><tv k="title1"></tv></div>
                    <div class="data-wrap">
                        <div class="data-content table-content">
                            <div class="table-line">
                                <div class="big-number">
                                    <span class="number c-o"><tv k="n1" min="3" max="5"></tv></span>
                                    <span class="name"><tv k="t1"></tv></span>
                                </div>
                                <div class="big-number">
                                    <span class="number c-o"><tv k="n2"></tv></span>
                                    <span class="name"><tv k="t2"></tv></span>
                                </div>
                                <div class="big-number">
                                    <span class="number c-b"><tv k="n3" min="3" max="8" time="5000"></tv></span>
                                    <span class="name"><tv k="t3"></tv></span>
                                </div>
                            </div>

                            <div class="table-line">
                                <div class="big-number">
                                    <span class="number c-b"><tv k="n4" min="3" max="8" time="10000"></tv></span>
                                    <span class="name"><tv k="t4"></tv></span>
                                </div>
                                <div class="big-number">
                                    <span class="number c-b"><tv k="n5"></tv></span>
                                    <span class="name"><tv k="t5"></tv></span>
                                </div>
                                <div class="big-number">
                                    <span class="number c-o"><tv k="n6"></tv></span>
                                    <span class="name"><tv k="t6"></tv></span>
                                </div>
                            </div>

                            <div class="table-line">
                                <div class="big-number">
                                    <span class="number c-q"><tv k="n7"></tv></span>
                                    <span class="name"><tv k="t7"></tv></span>
                                </div>
                                <div class="big-number">
                                    <span class="number c-q"><tv k="n8"></tv></span>
                                    <span class="name"><tv k="t8"></tv></span>
                                </div>
                                <div class="big-number"></div>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="group1">
                    <div class="sub-title"><tv k="title2"></tv></div>
                    <div class="data-wrap">
                        <div class="data-content grid-content box-shadow-r">
                            <table cellpadding="0" cellspacing="0" border="0">
                                <tr>
                                    <td><tv k="tb1"></tv></td>
                                    <td><tv k="tb2"></tv></td>
                                    <td><tv k="tb3"></tv></td>
                                    <td><tv k="tb4"></tv></td>
                                </tr>
                                <tr>
                                    <td><tv k="tb5"></tv></td>
                                    <td><tv k="tb6"></tv></td>
                                    <td><tv k="tb7"></tv></td>
                                    <td><tv k="tb8"></tv></td>
                                </tr>
                                <tr>
                                    <td><tv k="tb9"></tv></td>
                                    <td><tv k="tb10"  min="3" max="8" time="1000"></tv></td>
                                    <td><tv k="tb11" min="3" max="8" time="1000"></tv></td>
                                    <td><tv k="tb12" min="3" max="8" time="1000"></tv></td>
                                </tr>
                                <tr>
                                    <td colspan="4"><tv k="tb13"></tv></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="group1">
                    <div class="sub-title"><tv k="title3"/></div>
                    <div class="data-wrap">
                        <div class="data-content chart-content">
                            <div id="userDataChart"></div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="mid ">
                <div class="map-chart" >
                    <div id="mapView" style="height: 100%;"></div>
                </div>
                <div class="group1 bar-wrap">
                    <div class="data-wrap">
                        <div class="data-content bar-content ">
                            <div class="bar-title"><tv k="title4"/></div>
                            <div id="totalCountChart" style="height: 250px"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="group1">
                    <div class="data-wrap">
                        <div class="data-content pie-content box-shadow-r">
                            <div class="text-title none-h"><tv k="title5"/></div>
                            <div id="userFromBar" style="height: 320px"></div>
                        </div>
                    </div>
                </div>
                <div class="group1">
                    <div class="sub-title"><tv k="title6"/></div>
                    <div class="data-wrap">
                        <div class="data-content chart-content">
                            <div id="runningChart"></div>
                        </div>
                    </div>
                </div>
                <div class="group1">
                    <div class="sub-title"><tv k="title7"/></div>
                    <div class="data-wrap">
                        <div class="data-content camera-content">
                            <div id="cameraView" class="camera-view">
                                <span><tv k="title8"/></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SvgIcon from "../components/SvgIcon";
    import * as echarts from 'echarts';

    export default {
        name: 'Area',
        components: {SvgIcon},
        data() {
            return {
                userDataChart: null,
                userFromBar: null,
                runningChart: null,
                totalCountChart: null,
                mapView: null,
            }
        },
        mounted() {
            let self = this;
            this.$nextTick(_ => {
                this.userDataChart = echarts.init(document.querySelector('#userDataChart'));
                this.runningChart = echarts.init(document.querySelector('#runningChart'));
                this.userFromBar = echarts.init(document.querySelector('#userFromBar'));
                this.totalCountChart = echarts.init(document.querySelector('#totalCountChart'));
                this.mapView = echarts.init(document.querySelector('#mapView'));
                this.mapView.on('click', function (data) {
                    console.log('map click:', data, this);
                    self.$router.push('/device')
                });

                //this.mapView.showLoading();
                this.init();
            });
        },
        methods: {
            init() {
                let self = this;
                function getData(t) {
                    let _t = new Date(t),
                        _n = 0;
                    if(_t.getHours() > 9 && _t.getHours() < 21) {
                        _n = self.$t.randomNum(1000, 5000);
                    }
                    return {
                        t : self.$t.formatDate(t, 'hh:MM'),
                        n : _n
                    }
                }

                function getBaseData(){
                    let base = [
                        [],
                        []
                    ];

                    let now = Date.now();
                    let m = 1000 * 60 * 10;
                    for(let i = 0; i < 10; i++) {
                        let tmp = getData(now - (10 - i) * m);
                        base[0].push(tmp.t);
                        base[1].push(tmp.n)
                    }
                    return base;
                }


                let base1 = getBaseData();
                let base2 = getBaseData();


                function getOpt1() {
                    base1[0].splice(0, 1);
                    base1[1].splice(0, 1);

                    base2[0].splice(0, 1);
                    base2[1].splice(0, 1);

                    let tmp = getData(Date.now());
                    base1[0].push(tmp.t);
                    base1[1].push(tmp.n);
                    tmp = getData(Date.now() );
                    base2[0].push(tmp.t);
                    base2[1].push(tmp.n);

                    self.userDataChart.setOption(self.getChartsOptions(
                        base1[0],
                        base1[1]
                    ));
                    self.runningChart.setOption(self.getChartsOptions(
                        base2[0],
                        base2[1]
                    ));
                    self.userFromBar.setOption(self.getPieOptions());
                }

                setInterval(getOpt1, 10000);
                getOpt1();


                this.totalCountChart.setOption(this.getBarOptions());
                import('@/assets/map/china.json').then(res => {
                    echarts.registerMap('china', res);
                    this.mapView.setOption({
                        grid: {
                            left: 30,
                            right: 20,
                            bottom: 30,
                            top: 20,
                        },
                        visualMap: {
                            show: false,
                            min: 0,
                            max: 1000,
                            text: ['High', 'Low'],
                            realtime: false,
                            calculable: true,
                            inRange: {
                                color: ['#4DE2FE']
                            }
                        },
                        tooltip: {
                            show: true,
                            backgroundColor: '#00303f',
                            borderColor: '#124E5E',
                            textStyle: {
                                color: '#ffffff',
                            }
                        },
                        series: [
                            {
                                name: '设备统计',
                                type: 'map',
                                mapType: 'china', 
                                roam: false,
                                zoom: 1.7,
                                center: [105, 36],
                                //aspectScale: 1.5,
                                label: {
                                    show: false,
                                    color: '#ffffff'
                                },
                                itemStyle: {
                                    borderColor: 'rgba(23, 21, 58, 1)',
                                    areaColor: 'rgba(38,65,172, 1)',
                                    shadowColor: 'rgba(81,228,253, 1)',
                                    shadowBlur: 10,
                                    shadowOffsetX: -1,
                                    shadowOffsetY: -1,
                                    /*normal: {
                                        borderColor: '#32c5ff',
                                        borderWidth: 1,
                                        areaColor: {
                                            type: 'radial',
                                            x: 0.5,
                                            y: 0.5,
                                            r: 0.8,
                                            colorStops: [{
                                                offset: 0.5,
                                                color: 'rgb(9,32,125)' // 0% 处的颜色
                                            }, {
                                                offset: 1,
                                                color: 'rgb(64, 153, 217, .8)' // 100% 处的颜色
                                            }],
                                            globalCoord: false // 缺省为 false
                                        },
                                        shadowColor: 'rgba(128, 217, 248, 1)',
                                        // shadowColor: 'rgba(255, 255, 255, 1)',
                                        shadowOffsetX: -2,
                                        shadowOffsetY: 2,
                                        shadowBlur: 10
                                    },
                                    emphasis: {
                                        areaColor: '#389BB7',
                                        borderWidth: 0
                                    }*/
                                },
                                data: [
                                    {name: '重庆市', value: 500},
                                ],
                                nameMap: {}
                            }
                        ]
                    });
                })
            },
            getChartsOptions(x, data) {

                return {
                    tooltip: {
                        trigger: 'axis'
                    },
                    grid: {
                        left: 50,
                        right: 20,
                        bottom: 30,
                        top: 20,
                    },
                    xAxis: {
                        type: 'category',
                        data: x,
                        axisLine: {
                            lineStyle: {
                                color: '#ffffff',//坐标轴颜色
                            }
                        },
                    },
                    yAxis: {
                        type: 'value',
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: '#0A2445',//分割线颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#ffffff',//坐标轴颜色
                            }
                        },
                    },
                    series: [{
                        /*lineStyle: {
                           color: colors[0]
                        },*/
                        data: data,//;
                        type: 'line',
                        itemStyle: {
                            normal: {
                                color: '#44d7b6',//点颜色
                                lineStyle: {
                                    color: '#32C5FF',//线颜色
                                }
                            }
                        },
                        markPoint: {
                            itemStyle: {}
                        }
                    }]
                };
            },
            getPieOptions() {
                return {
                    legend: {
                        top: 'bottom',
                        left: 'center',
                        icon: 'roundRect',
                        textStyle: {
                            color: '#ffffff'
                        }
                    },
                    series: [
                        {
                            name: '访问来源',
                            type: 'pie',
                            radius: ['46%', '60%'],
                            center: ['50%', '40%'],
                            avoidLabelOverlap: true,
                            itemStyle: {
                                borderRadius: 0,
                                borderColor: '#fff',
                                borderWidth: 0
                            },
                            label: {
                                color: '#ffffff',
                                overflow: 'break',
                            },
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 0,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            },
                            labelLine: {
                                show: true
                            },
                            data: [
                                {value: this.$t.randomNum(850, 1048), name: '网络获取'},
                                {value: this.$t.randomNum(685, 735), name: '私域流量'},
                                {value: this.$t.randomNum(550, 580), name: '线下咨询'},
                            ]
                        }
                    ]
                };
            },
            getBarOptions() {
                let ONE_DAY = 1000 * 60 * 60 * 24;
                let [start, now] = this.$t.getDiffDay('15');
                let current = now.getTime(), xStr = [], yData1 = [], yData2 = [];
                do{
                    current = current - ONE_DAY;
                    xStr.push(this.$t.formatDate(new Date(current), 'MM月dd日'))
                    yData1.push(this.$t.randomNum(0, 80));
                    yData2.push(this.$t.randomNum(0, 80));
                } while(current > start.getTime());
                xStr.reverse();
                yData1.reverse();
                yData2.reverse();

                return {
                    xAxis: {
                        type: 'category',
                        data: xStr,
                        axisLine: {
                            lineStyle: {
                                color: '#ffffff',//坐标轴颜色
                            }
                        },
                    },
                    grid: {
                        left: 30,
                        right: 20,
                        bottom: 30,
                        top: 60,
                    },
                    legend: {
                        data: ['美团订单', '大众订单'],
                        right : 10,
                        top: 10,
                        textStyle: {
                            color: '#ffffff',
                        }
                    },
                    yAxis: {
                        type: 'value',
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: '#0A2445',//分割线颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#ffffff',//坐标轴颜色
                            }
                        },
                    },
                    series: [
                        {
                            data: yData1,
                            name: '美团订单',
                            type: 'bar',
                            itemStyle: {
                                color: '#ff5e5e',
                            },
                        },
                        {
                            name: '大众订单',
                            data:yData2,
                            type: 'bar',
                            itemStyle: {
                                color: '#32c5ff',
                            }
                        }
                    ]
                };
            }
        }
    }
</script>
<style lang="less">
    .area {
        .mid {
            padding: 0 20px;
        }

        .map-chart {
            flex-grow: 1;
            padding: 20px 0 30px;
        }

        .bar-wrap {
            flex-shrink: 0;

            .bar-content {
                position: relative;

                .bar-title {
                    font-size: 24px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 0px;
                    color: #ffffff;
                    position: absolute;
                    top: -63px;
                    left: -2px;
                    background: #050C2F url(../assets/img/bar-title-bg.png) no-repeat center center;
                    background-size: 100% auto;
                    padding: 28px 70.2px 21px 15px;
                    min-width: 500px;

                    &:before {
                        content: " ";
                        position: absolute;
                        left: 1px;
                        background-color: #3BC8F8;
                        height: 10px;
                        width: 1px;
                        top: 70px;
                    }
                }
            }
        }
    }
</style>
